<template>
  <div class="vis-container">
    <div class="vis-head">
      <div class="vis-head-title">海马AI智能硬件数据中心</div>
      <div class="vis-head-icons">
        <i class="el-icon-full-screen head-icon" @click="toggleFull"></i>
      </div>
    </div>

    <div class="vis-main">
      <div class="vis-grid">
        <!-- left  -->
        <div class="vis-left">
          <div class="box-item">
            <div class="box-title">设备类型数据</div>
            <div class="echart-box">
              <rowBar :data="deviceTypeCountData" ename="dt"></rowBar>
            </div>
          </div>
          <div class="box-item">
            <div class="box-title">设备在线状态</div>
            <div class="echart-box">
              <circle2 :data="lineOff" ename="offon"></circle2>
            </div>
          </div>
          <div class="box-item">
            <div class="box-title">设备安装情况</div>
            <div class="echart-box">
              <lineEc :data="installData" ename="install"></lineEc>
            </div>
          </div>
        </div>
        <!-- center -->
        <div class="vis-center">
          <div class="map-wrap">
            <div class="map-in-wrap">
              <mapEcharts height="35rem" name="hmap"></mapEcharts>
            </div>
          </div>

          <div class="ico-wrap">
            <div class="ico-item">
              <img
                src="https://img.curiousmore.com/hmpcozusi11757401605666.png"
                class="ico-pic"
              />
              <div class="ico-info">
                <div class="ico-name">总设备数量</div>
                <div class="ico-value">{{totalData.device || 0}}</div>
              </div>
            </div>
            <div class="ico-item">
              <img
                src="https://img.curiousmore.com/hmpc8af5k11757401614887.png"
                class="ico-pic"
              />
              <div class="ico-info">
                <div class="ico-name">总分成金额</div>
               <div class="ico-value">{{totalData.cash || 0}}</div>
              </div>
            </div>
            <div class="ico-item">
              <img
                src="https://img.curiousmore.com/hmpcfvil111757401623061.png"
                class="ico-pic"
              />
              <div class="ico-info">
                <div class="ico-name">总使用人次</div>
               <div class="ico-value">{{totalData.record || 0}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- right -->
        <div class="vis-right">
          <div class="box-item">
            <div class="box-title">分成数据</div>
            <div class="echart-box">
              <lineEc :data="incomeTimeData" ename="cash"></lineEc>
            </div>
          </div>
          <div class="box-item">
            <div class="box-title">分成排名</div>
            <div class="echart-box">
              <div class="ranks">
                <div class="rank-item" v-for="(v, i) in rankData" :key="i">
                  <div class="rank-index">{{ i + 1 }}</div>
                  <div class="rank-name">
                    {{ v.name }}
                  </div>
                  <div class="rank-cash">¥{{ v.amount }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-item">
            <div class="box-title">分成类型统计</div>
            <div class="echart-box">
              <circleType :data="typeCash" ename="cashType"></circleType>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toggleFullScreen } from "../../js/fullScreen.js";
import circle2 from "./components/hardware/circle2.vue";
import circleType from "./components/hardware/circleType.vue";
import mapEcharts from "./components/hardware/hardMap.vue";
import lineEc from "./components/hardware/lineEc.vue";
import rowBar from "./components/hardware/rowBar.vue";
import { useXYData, commXYData } from "@/utils/echartsUtils.js";
export default {
  components: {
    rowBar,
    circle2,
    lineEc,
    mapEcharts,
    circleType,
  },
  data() {
    return {
      incomeTimeData: {},
      deviceTypeCountData: {},
      lineOff: {
        off: 0,
        on: 0,
      },
      rankData: [],
      installData: {},
      typeCash: [],
      totalData:{}
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      var n = new Date();
      let s = new Date(n.setDate(1)).Format("yyyy-MM-dd") + " 00:00:00";
      let e = new Date().Format("yyyy-MM-dd") + " 23:59:59";
      let t = {
        list: [s, e],
        mode: "本月",
      };
        this.getInstallByTime(t);
      this.getIncomeByTime(t);
    
      this.getDeviceTypeCountData();
      this.getDeviceActiveCountData();
      this.getCashByType(t)
      this.getRankData(t)
      this.getTotalData()
    },
    toggleFull() {
      toggleFullScreen();
    },
    handlerParam(v) {
      let params = {
        start_time: v.list[0],
        end_time: v.list[1],
      };
      if (v.mode == "今日") {
        params.mode = "hour";
      } else if (v.mode == "本年") {
        params.mode = "moth";
      } else {
        params.mode = "day";
      }
      return params;
    },
     getTotalData() {
      let path = "/device/device/totalData";
      this.$get(path, {}).then((res) => {
        let list = res.data.data;
        this.totalData = list
      });
    },
    //设备类型数量
    getDeviceTypeCountData() {
      let path = "/device/device/statGroupByType";
      this.$get(path, {}).then((res) => {
        let list = res.data.data;
        let data = commXYData(list, {
          x: "name",
          y: "count",
        });
        this.deviceTypeCountData = data;
      });
    },
    getDeviceActiveCountData() {
      let path = "/device/device/statGroupByActive";
      this.$get(path, {}).then((res) => {
        let list = res.data.data;
        list.forEach((item) => {
          if (item.name == "off") {
            this.lineOff.off = item.count;
          } else if (item.name == "on") {
            this.lineOff.on = item.count;
          }
        });
      });
    },
    //安装数据
    getInstallByTime(v) {
      let params = this.handlerParam(v);
      let path = "/device/device/statByTime";
      this.$get(path, params).then((res) => {
        let list = res.data.data;
        let data = useXYData(v, list, {
          x: "time",
          y: "count",
        });
        this.installData = data;
      });
    },
    getRankData(v) {
      let params = this.handlerParam(v);
      let path = "/user/adminBonusLog/diCashRank";
      this.$get(path, params).then((res) => {
        this.rankData = res.data.data.slice(0,4)
      });
    },
    //收入图统计
    getIncomeByTime(v) {
      let params = this.handlerParam(v);
      params.source = "device";
      let path = "/user/adminBonusLog/incomeLineEcharts";
      this.$get(path, params).then((res) => {
        let list = res.data.data;
        let data = useXYData(v, list, {
          x: "time",
          y: "count",
        });
        this.incomeTimeData = data;
      });
    },
    //收入类型
    getCashByType(v) {
      let params = this.handlerParam(v);
      params.source = "device";
      let path = "/user/adminBonusLog/cashSumByType";
      this.$get(path, params).then((res) => {
        let list = res.data.data;
        let types = {
            '押金': 0,
            '分账收益': 0,
            '流量收益': 0,
            '服务费': 0,
            '安装费': 0,

        }
        let d = []
        list.forEach((item) => {
          if (item.type === 21) {
           types['分账收益'] = item.cash;
          }
          if (item.type === 22) {
            types['流量收益'] = item.cash;
          }
          if (item.type === 23) {
           types['押金'] = item.cash;
          }
        });
        for(let k of Object.keys(types)){
            d.push({
                name:k,
                value:types[k]
            })
        }
        this.typeCash = d
      });
    },
  },
};
</script>

<style lang="less" scoped>
.vis-container {
  width: 100vw;
  height: 100vh;
  background-image: url("https://img.curiousmore.com/hmpcgqpzi11745474736192.png");
  background-size: 100vw 100vh;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.vis-head {
  text-align: center;
  position: relative;
  height: 4rem;
}

.vis-head-title {
  font-weight: bold;
  font-size: 2.2rem;
  line-height: 1.5;
  color: #fff;
}

.vis-head-icons {
  position: absolute;
  top: 1rem;
  right: 2rem;
}
.head-icon {
  color: #19d6ff;
  font-size: 1.5rem;
  margin-right: 1rem;
}
.vis-main {
  margin: 0 auto;
  box-sizing: border-box;
  height: calc(100vh - 8rem);
  width: calc(100vw - 10rem);
  position: relative;
}
.vis-grid {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 24% 52% 24%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: calc(100vh - 8rem);
}
.vis-left {
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  gap: 1rem;
}
.vis-center {
  padding: 0 1.7rem;
  //   height: 80vh;
}
.vis-right {
  width: 100%;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  gap: 1rem;
}

.vis-box {
}

.mtop {
  margin-top: 1rem;
}

.box-item {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.box-title {
  background-image: url("https://img.curiousmore.com/hmpc3iwza11745474772933.png");
  background-size: 22rem 2.4rem;
  height: 2.4rem;
  background-repeat: no-repeat;
  color: #fff;
  font-size: 1rem;
  padding-left: 2.7rem;
  margin-bottom: 0.8rem;
  box-sizing: border-box;
  line-height: 1.8;
  flex-shrink: 0;
}
.echart-box {
  flex: 1;
}

.map-wrap {
  background-image: url("https://img.curiousmore.com/hmpcua63511757387123662.png");
  background-size: 90% 30rem;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 37rem;
  box-sizing: border-box;
  position: relative;
}
.map-in-wrap {
  box-sizing: border-box;
  position: relative;
}
.map-tab {
  position: absolute;
  right: 2rem;
  top: 1rem;
  z-index: 20;
}

.ranks {
  .rank-item {
    display: flex;
    background: linear-gradient(
      180deg,
      rgba(0, 128, 254, 0.1) 0%,
      rgba(0, 128, 254, 0.2) 100%
    );
    height: 2.3rem;
    box-sizing: border-box;
    align-items: center;
    font-size: 0.9rem;
    color: #fff;
    padding: 0.2rem 0.7rem;
    width: 21rem;
  }
  .rank-index {
    font-weight: 600;
    margin-right: 1rem;
    color: #eee;
  }
  .rank-name {
    flex: 1;
    margin-right: 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
  .rnak-cash {
    width: 5rem;
  }
  .rank-item + .rank-item {
    margin-top: 0.5rem;
  }
}

.ico-wrap {
  padding: 0 1.7rem;
  display: flex;
  justify-content: space-between;
  .ico-item {
    display: flex;
    .ico-pic {
      width: 5rem;
      height: 4.5rem;
      margin-right: 1rem;
      border-radius: 0 0 2.5rem 2.5rem;
    }
    .ico-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .ico-name {
      font-size: 0.8rem;
      color: #7fcff4;
    }
    .ico-value {
      font-weight: bold;
      font-size: 1.2rem;
      color: #7fcff4;
      margin-top: 0.7rem;
    }
  }
}
</style>
